import { LitElement, html, css, unsafeCSS } from 'lit';
import { RDPropsetContainer } from '../Container/PropContainer.js';

import styles from './TextArea.css?raw';

export class propTextArea extends RDPropsetContainer {
  static styles = [
    super.styles,
    css`
      ${unsafeCSS(styles)}
    `,
  ];
  static properties = {
    value: { type: String },
    disabled: { type: Boolean, reflect: true },
    placeholder: { type: String },
    onInput: { type: Function },
    onChange: { type: Function },
    callback: { type: Function },
  };
  constructor() {
    super();
    this.label = '';
    this.value = '';
    this.disabled = false;
    this.placeholder = '';
    this.onInput = null;
    this.onChange = null;
    this.callback = null;
  }

  _onInput(e) {
    this.value = e.target.value;
    if (this.onInput && typeof this.onInput === 'function') {
      this.onInput.bind(this)(this.value || '');
    }
    if (this.callback && typeof this.callback === 'function') {
      this.callback.bind(this)(this.value || '');
    }
    this.dispatchEvent(new CustomEvent('prop-value-input', { detail: { value: this.value || 0 } }));
  }
  _onChange(e) {
    if (this.onChange && typeof this.onChange === 'function') {
      this.onChange.bind(this)(this.value || '');
    }
    if (this.callback && typeof this.callback === 'function') {
      this.callback.bind(this)(this.value || '');
    }
    this.value = e.target.value;
    this.dispatchEvent(new CustomEvent('prop-value-changed', { detail: { value: this.value || '' } }));
  }

  _renderTextInput() {
    return html`
      <div class="text-input">
        <textarea placeholder="${this.placeholder || ''}" .value="${this.value}" ?disabled="${this.disabled || this._partialDisabled}" @input="${this._onInput}" @change="${this._onChange}"></textarea>
      </div>
    `;
  }

  renderBody() {
    return html`<div class="option-container" tabindex="-1">${this._renderTextInput()}</div>`;
  }
}
if (!customElements.get('rd-prop-text-area')) {
  customElements.define('rd-prop-text-area', propTextArea);
}
